import CreatePropertySuccessModal from "./CreatePropertySuccessModalContainer";

export default CreatePropertySuccessModal;
